import {
  ICancellationData,
  ISelectedPayment,
  TPaidPayment
} from 'features/Bookings/components/CancelTicketsModal/types'
import { IBookingModel } from 'features/Bookings/types'
import {
  GTBookingV2,
  GTBookingV2Payment,
  GTBookingV2PaymentStatus,
  GTBookingV2TicketStatus,
  GTRefundDestinationInput
} from 'gql/types.generated'
import { round, sanitizePrice } from 'utils/math'

export const getPaidPayments = (booking: GTBookingV2): TPaidPayment[] => {
  const paidPayments: TPaidPayment[] = booking.payments
    .filter((payment) => payment.status === GTBookingV2PaymentStatus.Paid)
    .map((payment) => {
      const amountRefunded = booking.refunds.reduce((amount, refund): TSFixMe => {
        if (refund.paymentID === payment.id) {
          return amount + Math.abs(refund.amount)
        } else {
          return amount
        }
      }, 0)
      return {
        ...payment,
        amount: sanitizePrice(payment.amount - amountRefunded)
      }
    })
    .filter((payment) => payment.amount > 0)
  return paidPayments
}
export const getPaidPaymentsV2 = (booking: GTBookingV2): GTBookingV2Payment[] => {
  const paidPayments = booking.payments.filter((payment) => payment.status === GTBookingV2PaymentStatus.Paid)

  return paidPayments
}

export const sortPaymentsByRefundPriority = (
  paidPayments: ISelectedPayment[],
  refundDestination: GTRefundDestinationInput
): ISelectedPayment[] => {
  return paidPayments
    .filter((payment) => payment.processor?.includes(refundDestination))
    .concat(paidPayments.filter((payment) => !payment.processor?.includes(refundDestination)))
}

export const getUncancelledTicketsIds = (booking: GTBookingV2): string[] => {
  return booking.tickets.filter(({ status }) => status !== GTBookingV2TicketStatus.Cancelled).map(({ id }) => id)
}

export const mapBookingToCancelBookingForm = (
  booking: IBookingModel,
  isNewCancelationFlow?: boolean
): ICancellationData => {
  const paidPayments = isNewCancelationFlow ? getPaidPaymentsV2(booking) : getPaidPayments(booking)
  const defaultRefundDestination = booking.isTaxInvoiced
    ? GTRefundDestinationInput.Card
    : GTRefundDestinationInput.Kredit
  return {
    selectedTicketsIds: getUncancelledTicketsIds(booking),
    selectedPayments: paidPayments.map((payment) => {
      return {
        processor: payment.processor,
        paymentId: payment.id,
        paidAmount: payment.amount,
        amountToRefund: round(payment.amount / 100, 2)
      }
    }),
    reason: '',
    refundDestination: defaultRefundDestination
  }
}
